export const API_BASE =
  process.env.REACT_APP_BACKEND_URL || process.env.REACT_APP_API_BASE || "";

export async function getConfig() {
  const res = await fetch(`${API_BASE}/api/config`);
  return res.json();
}

export async function submitLead(lead) {
  const res = await fetch(`${API_BASE}/api/leads`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(lead),
  });
  return res.json();
}
